export function categorizeProperties(properties, contacts, outreachLog, institutionalOwners, settings) {
  const cooldownDays = parseInt(settings.cooldown_days || '14', 10);
  const cutoff = new Date(Date.now() - cooldownDays * 24 * 60 * 60 * 1000);

  const institutionalNames = new Set(
    institutionalOwners.map(o => o.name.toLowerCase().trim())
  );

  const buckets = { ready: [], missing: [], recent: [], institutional: [] };

  for (const prop of properties) {
    const ownerLower = (prop.owner_name || '').toLowerCase().trim();

    // 1. Institutional check — partial match
    let isInstitutional = false;
    for (const inst of institutionalNames) {
      if (ownerLower.includes(inst) || inst.includes(ownerLower)) {
        isInstitutional = true;
        break;
      }
    }
    if (isInstitutional && ownerLower) {
      buckets.institutional.push({ ...prop, bucket: 'institutional' });
      continue;
    }

    // 2. Outreach history — ANY logged outreach moves the property to
    // "Contacted Recently" permanently. We do not bounce the property back
    // to "Ready to Send" once a cooldown elapses; the user can re-send
    // explicitly from the Recent bucket if they want. This matches the
    // expectation that "sending an LOI moves the property out of Ready."
    const propOutreach = outreachLog
      .filter(o => o.property_id === prop.id && o.sent_at)
      .sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));

    if (propOutreach.length > 0) {
      const lastOutreach = propOutreach[0];
      const sentDate = new Date(lastOutreach.sent_at);
      const daysSince = Math.floor((Date.now() - sentDate) / (24 * 60 * 60 * 1000));
      buckets.recent.push({
        ...prop,
        bucket: 'recent',
        last_contacted: lastOutreach.sent_at,
        days_since: daysSince,
        days_until_eligible: Math.max(0, cooldownDays - daysSince),
        sent_by: lastOutreach.sent_by,
        ready_on: new Date(sentDate.getTime() + cooldownDays * 24 * 60 * 60 * 1000).toISOString(),
      });
      continue;
    }
    // Reference `cutoff` so the unused-var lint stays happy — the value is
    // kept available in case we re-introduce a time-gated "Ready again" path.
    void cutoff;

    // 3. Contact check — find a contact with an email
    let contact = contacts.find(c => c.property_id === prop.id && c.email1);
    if (!contact && prop.owner_name) {
      contact = contacts.find(c =>
        c.owner_name && c.email1 &&
        c.owner_name.toLowerCase().includes(prop.owner_name.toLowerCase())
      );
    }

    if (!contact) {
      buckets.missing.push({ ...prop, bucket: 'missing' });
      continue;
    }

    // 4. Ready to send
    buckets.ready.push({ ...prop, bucket: 'ready', contact });
  }

  return buckets;
}
